import { ActionIcon } from "@mantine/core";
import { IconPresentationAnalytics } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTheme } from "src/hooks";
import { type IHistoryItem } from "src/interfaces";
import { Flex, StyledTd, StyledTr } from "src/styled";
interface Props extends IHistoryItem {
  setSelectedRow: (row: any) => void;
}
const ModalItem = ({
  action,
  timestamp,
  archived,
  rolename,
  full_name,
  setSelectedRow,
  ...props
}: Props) => {
  useTheme();
  const actionName = useMemo(
    () => (archived ? "Archived" : action),
    [archived, action],
  );

  return (
    <StyledTr>
      <StyledTd style={{ padding: 10, textAlign: "center" }}>
        {actionName}
      </StyledTd>
      <StyledTd style={{ padding: 10, textAlign: "center" }}>
        {dayjs(timestamp).format("DD MMM YYYY hh:mm:ss")}
      </StyledTd>
      <StyledTd style={{ padding: 10, textAlign: "center" }}>
        {rolename}
      </StyledTd>
      <StyledTd style={{ padding: 10, textAlign: "center" }}>
        {full_name}
      </StyledTd>
      {archived && (
        <StyledTd>
          <Flex justify="center" align="center">
            <ActionIcon onClick={() => setSelectedRow(props)}>
              <IconPresentationAnalytics />
            </ActionIcon>
          </Flex>
        </StyledTd>
      )}
    </StyledTr>
  );
};
export default ModalItem;
